const galleryItems = [
  {
    label: "Office Split AC Installation",
    image: "/images/hvac/split-ac.webp",
    span: "col-span-2",
  },
  {
    label: "Air Handling Unit Plant Room",
    image: "/images/hvac/ahu.webp",
    span: "col-span-1",
  },
  {
    label: "Ductwork Fabrication",
    image: "/images/hvac/ductwork.webp",
    span: "col-span-1",
  },
  {
    label: "Industrial Ventilation Fans",
    image: "/images/hvac/ventilation.webp",
    span: "col-span-2",
  },
  {
    label: "Rooftop Exhaust & Fresh Air",
    image: "/images/hvac/exhaust.webp",
    span: "col-span-1",
  },
  {
    label: "Data Centre Precision Cooling",
    image: "/images/hvac/precision-cooling.webp",
    span: "col-span-1",
  },
];

export default function HvacGallery() {
  return (
    <section id="gallery" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-14">
          <span className="text-teal-600 text-xs font-semibold uppercase tracking-widest mb-3 block">Our Work</span>
          <h2 className="text-gray-900 text-4xl md:text-5xl font-extrabold uppercase tracking-tight">
            Project Gallery
          </h2>
          <p className="text-gray-500 text-sm mt-4 max-w-xl mx-auto leading-relaxed">
            A snapshot of HVAC systems we&apos;ve engineered and installed across Kenya — hotels, hospitals, offices, factories and more.
          </p>
        </div>

        {/* Gallery grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {galleryItems.map((item, i) => (
            <div
              key={i}
              className={`relative overflow-hidden rounded-lg group ${item.span === "col-span-2" ? "lg:col-span-2" : ""}`}
            >
              <div className="w-full h-64 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.label}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-5">
                <span className="text-white font-semibold text-sm uppercase tracking-wide">
                  {item.label}
                </span>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="text-center mt-12">
          <a
            href="#inquiry"
            onClick={(e) => { e.preventDefault(); document.querySelector("#inquiry")?.scrollIntoView({ behavior: "smooth" }); }}
            className="inline-flex items-center gap-2 bg-teal-600 hover:bg-teal-500 text-white font-bold px-8 py-3 rounded-md uppercase text-sm tracking-wider transition-colors cursor-pointer whitespace-nowrap"
          >
            Start Your HVAC Project
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}
